import { render, staticRenderFns } from "./ylkt5.vue?vue&type=template&id=2d7a47e8&scoped=true&"
import script from "./ylkt5.vue?vue&type=script&lang=js&"
export * from "./ylkt5.vue?vue&type=script&lang=js&"
import style0 from "./ylkt5.vue?vue&type=style&index=0&id=2d7a47e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7a47e8",
  null
  
)

export default component.exports